import { useGetCreatorTurnAroundTimeQuery } from "@/redux/feature/creatorTat/creatorTatApi";
import { useAppSelector } from "@/redux/hooks/hooks";
import InfoIcon from "@/assets/icons/InfoCircle.svg";

const CreatorTats = () => {
  const { user } = useAppSelector((state) => state.auth);

  const { data: turnAroundDTO } = useGetCreatorTurnAroundTimeQuery({
    email: user?.email as string,
  });

  return (
    <div className="bg-white rounded-lg border border-gray-200 px-4 sm:px-6 py-4 sm:py-6 max-w-full sm:max-w-[575px] shadow-lg">
      {/* Rating Section */}
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <div className="flex items-center gap-3 sm:gap-4">
          {/* badge */}
          <p className="text-sm sm:text-base font-medium font-grotesk px-3 py-1 border-[0.5px] border-[#B8B8B8] rounded-full">
            Ratings
          </p>
          <h6 className="text-2xl sm:text-[36px] font-medium text-[#202020] leading-[1.2] sm:leading-[22px] tracking-[-0.5%] font-grotesk">
            {turnAroundDTO?.data?.totalProjectsCompleted}
          </h6>
        </div>
        <p className="text-xs sm:text-sm text-[#667085] leading-4 sm:leading-5 tracking-tight">
          Creators with this turnaround typically handle <br />
          <span className="text-[#FF6600] font-medium">
            {turnAroundDTO?.data?.totalProjectsCompleted} projects monthly.
          </span>
        </p>
      </div>

      {/* TAT Section */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <div className="flex items-center gap-3 sm:gap-4">
          {/* badge */}
          <span className="text-sm sm:text-base font-medium font-grotesk px-3 py-1 border-[0.5px] border-[#B8B8B8] rounded-full flex items-center gap-x-1">
            TAT
            <InfoIcon />
          </span>
          <div className="text-xl sm:text-2xl font-medium text-[#202020] leading-[1.2] sm:leading-[22px] tracking-[-0.5%] font-grotesk flex flex-row md:flex-col gap-x-3 gap-y-1 items-center md:items-start">
            {turnAroundDTO?.data?.averageCompletionDays} Days
            <div className="bg-[#D9FBD0] rounded-[4px] px-[18.5px] py-[4.5px] border border-[#BEE8B4] w-fit">
              <p className="text-[#1C6C09] text-[10px] leading-[73%] tracking-[2%] font-semibold">
                Good
              </p>
            </div>
          </div>
        </div>
        <p className="text-xs sm:text-sm text-[#667085] leading-4 sm:leading-5 tracking-tight">
          Creators with this turnaround typically handle <br />
          <span className="text-[#FF6600] font-medium">
            {turnAroundDTO?.data?.totalProjectsCompleted} projects monthly.
          </span>
        </p>
      </div>
    </div>
  );
};

export default CreatorTats;
